import React from 'react';

const CellCheckboxAMPUTPrice = ({price, currencyMap}) => {
    const value = price.price === null || price.price=== undefined ? 0 : price.price.toFixed(3)
    return (
        price && <div style={{display: 'flex', alignItems: 'center', height: '13px', lineHeight: '13px'}}>
            <div style={{marginLeft: '0px'}}>{value} {currencyMap.get(price.currencyId)?.curAbbreviation}</div>
        </div>
    );
};

export default CellCheckboxAMPUTPrice;